export default "__VITE_ASSET__DvIUPKcs__"